<template>
    <loader v-if="loading" />
    <v-row v-else>
        <v-col cols="3" v-for="({ text, value, formatter }, index) in totalCards" :key="index">
            <v-card height="127">
                <v-card-subtitle class="">{{ text }}</v-card-subtitle>
                <v-divider />
                <v-card-text>
                    <div v-if="loading" style="height: 100%" class="d-flex justify-center align-center">
                        <v-icon size="30px" class="fa-spin" >
                            fa-spinner
                        </v-icon>                    
                    </div>
                    <div v-else>
                        <div class="display-1 text--primary">{{ formatter(value(stats)) }}</div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data () {
        return {
            loading: true,
            stats: null,
            totalCards: [
                {
                    text: 'Præmie strakssalg',
                    value: (stats) => stats.immediateValue,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Præmie tilbudssalg',
                    value: (stats) => stats.offerValue,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Præmie mersalg',
                    value: (stats) => stats.additionalValue,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Præmie total',
                    value: (stats) => stats.immediateValue + stats.offerValue + stats.additionalValue,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Antal møder',
                    value: (stats) => stats.allMeetingsCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Gennemførte møder',
                    value: (stats) => stats.completedCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Reklamationer',
                    value: (stats) => stats.complaintCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Aflyste møder',
                    value: (stats) => stats.canceledCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Aflysningsprocent',
                    value: (stats) => stats.cancelrate,
                    formatter: this.$options.filters.percentage
                },
                {
                    text: 'Møder lukket som strakssalg',
                    value: (stats) => stats.immediateSalesCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Møder afgivet tilbud',
                    value: (stats) => stats.offerCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Møder lukket som afslag',
                    value: (stats) => stats.immediateDeclinedCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Tilbud lukket som salg',
                    value: (stats) => stats.offerSalesCount,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Hitrate',
                    value: (stats) => stats.hitrate,
                    formatter: this.$options.filters.percentage
                },
                {
                    text: 'Gns. præmie pr. gennemført møde',
                    value: (stats) => (stats.immediateValue + stats.offerValue) / (stats.completedCount || 1),
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Gns. præmie pr. salg',
                    value: (stats) => stats.immediateSalesCount + stats.offerSalesCount
                    ? (stats.immediateValue + stats.offerValue) / (stats.immediateSalesCount + stats.offerSalesCount)
                    : (stats.immediateValue + stats.offerValue),
                    formatter: this.$options.filters.separator
                }
            ]
        }
    },
    computed: {
        team () {
            return this.$store.state.meetings.team
        },
        salesAgent () {
            return this.$store.state.meetings.salesAgent
        },
        bookingAgentOrgCode () {
            return this.$store.state.meetings.bookingAgentOrgCode
        },
        bookingCampaign () {
            return this.$store.state.meetings.bookingCampaign
        },
        period () {
            return this.$store.state.meetings.statsPeriod
        },
        range () {
            return this.$store.state.meetings.statsRange
        },
        type () {
            return this.$store.state.meetings.type
        },
        onlyRebooking () {
            return this.$store.state.meetings.onlyRebooking
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let team, department
            if (this.$store.state.meetings.team === 'Alle teams') {
                team = null
            } else if (this.$store.state.meetings.team === 'tryg') {
                department = 'tryg'
            } else if (this.$store.state.meetings.team === 'alka') {
                department = 'alka'
            } else {
                team = this.$store.state.meetings.team
            }
            const response = await this.$http().get('booking/stats/summary', {
                params: {
                    salesAgent: this.salesAgent,
                    team,
                    department,
                    bookingAgentOrgCode: this.bookingAgentOrgCode,
                    bookingCampaign: this.bookingCampaign,
                    onlyRebooking: this.onlyRebooking,
                    from: this.range[0],
                    to: this.range[1],
                    type: this.type
                }
            })
            this.stats = response.data
            this.loading = false
        }
    },
    watch: {
        team: function () {
            this.getData()
        },
        salesAgent: function () {
            this.getData()
        },
        bookingAgentOrgCode: function () {
            this.getData()
        },
        bookingCampaign: function () {
            this.getData()
        },
        period: function () {
		    this.$store.commit("meetings/setRange", { range: 'statsRange', preset: this.$store.state.meetings.statsPeriod });
        },
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
        type: function () {
            this.getData()
        },
        onlyRebooking: function () {
            this.getData()
        }
    },
    created () {
        this.getData()
    }
}
</script>